import React, { Component } from 'react';
import Link from 'next/link';
import FooterStyles from './FooterStyles';

class FooterComponent extends Component {
  constructor(props) {
    super(props);

    this.phone = this.props.phone || '18002226868';
  }

  render() {
    return (
      <FooterStyles>
        <div className="container">
          <div className="foot-notes">
            <div className="row justify-content-between">
              <div className="col-lg-3 term-links-col">
                <p className="phone-wrap">
                  <a href="tel:18887490121">1-888-749-0121</a>
                </p>
              </div>
              <div className="col-lg-6">
                <p>
                  ClientBooks &copy; {new Date().getFullYear()} All Rights Reserved.{' '}
                  <Link href="/privacy-policy">
                    <a>Privacy Policy</a>
                  </Link>{' '}
                  |{' '}
                  <Link href="/terms-of-service">
                    <a>Terms of Service</a>
                  </Link>
                  .
                </p>
              </div>
            </div>
          </div>
        </div>
      </FooterStyles>
    );
  }
}

export default FooterComponent;
